import { useNavigate } from "react-router-dom";
import BranchAdminAccess from "./BranchAdminAccess";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBranchAdminUserDetails, getCostCenterGridByUserId, getIsCostCenterSavedSuccessfully, getIsCostCenterValidForSave, getRemoveCostCenterForUser, getUserOnSearch, setBranchAdminUserDetails, setCostCenterGridByUserId, setIsCostCenterSavedSuccessfully, setIsCostCenterValidForSave, setIsRemoveCostCenterForUser, setUserOnSearch } from "Store/AssetInventory/BranchAdminAccess/BranchAdminAccessAction";
import moment from 'moment';
import { getCostCenterBySearchString } from "Store/Organization/CostCenters/CostCentersAction";
import { popupInitialData } from "utils";
import ConfirmationBee from '../../../../assets/images/ConfirmationBee.svg';
import SuccessBee from '../../../../assets/images/SuccessBee.svg'
import userProfileSelectors from '../../../../../redux/UserProfile/selectors';
import permissions, { isAuthorized } from "client/utils/Permissions";

const BranchAdminAccessContainer = (props: any) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [userSearchText, setUserSearchText] = useState<string>("");
    const [userOptions, setUserOptions] = useState<any>([]);
    const [tableData, setTableData] = useState<any>([]);
    const [showModalPopup, setShowModalPopup] = useState<boolean>(false);
    const [costCentersBySearchList, setCostCentersBySearchList] = useState([]);
    const [costCenterSearchText, setCostCenterSearchText] = useState<string>("")
    const [selectedSearchedCostCenter, setSelectedSearchedCostCenter] = useState<any>();
    const [PopupContent, setPopupContent] = useState<any>(popupInitialData);
    const [costCenterError, setCostCenterError] = useState<string>("");

    const [pagesCount, setPagesCount] = useState<number>(0)
    const [serverTotal, setServerTotal] = useState(0)
    const sortData: any = useRef();
    const paginationData: any = useRef();
    const [showGrid, setShowGrid] = useState<boolean>(false)
    const [gridColumn, setGridColumn] = useState<any>([])

    const {
        userListOnSearch,
        branchAdminUserDetails,
        costCenterGridByUserId,
        costCenterBySearchDropDownList,
        isCostCenterValidForSave,
        isCostCenterSavedSuccessfully,
        loginUserDetails,
        isRemoveCostCenterForUser
    }: any = useSelector((state: any) => ({
        userListOnSearch: state.BranchAdminAccessReducer?.userListOnSearch,
        branchAdminUserDetails: state.BranchAdminAccessReducer?.branchAdminUserDetails,
        costCenterGridByUserId: state.BranchAdminAccessReducer?.costCenterGridByUserId,
        costCenterBySearchDropDownList: state.CostCentersReducer.costCenterBySearchDropDownList,
        isCostCenterValidForSave: state.BranchAdminAccessReducer?.isCostCenterValidForSave,
        isCostCenterSavedSuccessfully: state.BranchAdminAccessReducer?.isCostCenterSavedSuccessfully,
        loginUserDetails: userProfileSelectors.getUserDetails(state),
        isRemoveCostCenterForUser: state.BranchAdminAccessReducer?.isRemoveCostCenterForUser
    }));

    const authorizeWithPermission = () => {
        if (loginUserDetails?.permissions && !isAuthorized(permissions.View_Branch_Admin_CostCenter)) {
            navigate('/assetinventory')
        }
    }

    useEffect(() => {
        authorizeWithPermission()
    }, [loginUserDetails])

    useEffect(() => {
        authorizeWithPermission()
        hideDialog()
        setShowGrid(false)
        setShowModalPopup(false)
        setGridColumn([])

        return () => {
            dispatch(setIsCostCenterSavedSuccessfully(null))
            dispatch(setIsCostCenterValidForSave(null))
            setCostCentersBySearchList([])
            dispatch(setUserOnSearch([]))
            dispatch(setBranchAdminUserDetails(null))
            dispatch(setCostCenterGridByUserId(null))
        }
    }, [])

    useEffect(() => {
        if (costCenterBySearchDropDownList?.length) {
            const costcenterDropdownListTemp = costCenterBySearchDropDownList?.map((item: any) => ({ ...item, label: item?.text }));
            setCostCentersBySearchList(costcenterDropdownListTemp);
        }
    }, [costCenterBySearchDropDownList])

    useEffect(() => {
        if (isRemoveCostCenterForUser != null) {
            if (isRemoveCostCenterForUser) {
                commonPopupDialog("SUCCESS", "Cost Center has been removed successfully!!", "Ok", true, null, SuccessBee, "successPopup", null)
            } else {
                commonPopupDialog("ERROR", "Error occured while removing Cost Center!!", "Ok", true, null, ConfirmationBee, "errorPopup", null)
            }
            dispatch(setIsRemoveCostCenterForUser(null))
        }
    }, [isRemoveCostCenterForUser])

    useEffect(() => {
        if (userListOnSearch?.length !== 0 && userListOnSearch !== null) {
            let userListOnSearchTemp = userListOnSearch?.map((item?: any) => ({ ...item, label: item?.text }))
            setUserOptions(userListOnSearchTemp)
        }
    }, [userListOnSearch])

    useEffect(() => {
        if (isCostCenterValidForSave !== null) {
            if (isCostCenterValidForSave) {
                dispatch(getIsCostCenterSavedSuccessfully({
                    costCenterId: selectedSearchedCostCenter?.value,
                    savedBy: loginUserDetails?.emailId,
                    userId: selectedUser?.value
                }))
            } else if (!isCostCenterValidForSave) {
                setCostCenterError("Selected Cost Center is already exist for user!!");
            }
            dispatch(setIsCostCenterValidForSave(null))
        }
    }, [isCostCenterValidForSave])

    useEffect(() => {
        if (isCostCenterSavedSuccessfully !== null) {
            if (isCostCenterSavedSuccessfully) {
                let decriptionTxt = (<p>Cost Center has been added successfully!!</p>);
                commonPopupDialog("SUCCESS", decriptionTxt, "Ok", true, null, SuccessBee, "successPopup", null)
            } else if (!isCostCenterSavedSuccessfully) {
                let decriptionTxt = (<p>Error occured while adding Cost Center!!</p>);
                commonPopupDialog("ERROR", decriptionTxt, "Ok", true, null, ConfirmationBee, "errorPopup", null)
            }
            dispatch(setIsCostCenterSavedSuccessfully(null))
        }
    }, [isCostCenterSavedSuccessfully])

    const assignColumns = () => {
        const columns = [
            {
                key: "costCenter",
                title: "Cost Center",
                Cell: (row: any) => {
                    return (
                        <p>{row.rowData.costCenterCode} - {row.rowData.costCenterName}</p>
                    )
                }
            },
            {
                key: "dateAssigned",
                title: "Date Assigned",
                Cell: (row: any) => {
                    return (
    
                        <p>{moment(row?.rowData?.dateAssigned).format('MM/DD/YYYY')}</p>
                    )
                },
                isSortable: false
            },
            {
                key: "assignedBy",
                title: "Assigned By",
                isSortable: false
            },
    
        ];

        if (loginUserDetails?.permissions && isAuthorized(permissions.Remove_Branch_Admin_CostCenter)){
            columns.push({
                key: "action",
                title: "Action",
                Cell: (row: any) => {
                    return row.rowData.isHomeCostCenter
                        ? <span style={{ display: "none" }} />
                        : <a href="#" onClick={(e: any) => { onClickRemove(e, row.rowData) }}>Remove</a>;
                },
                isSortable: false
            })
        }
        setGridColumn(columns)
    }

    useEffect(() => {
        if (costCenterGridByUserId?.length !== 0 && costCenterGridByUserId !== null) {
            setTableData(costCenterGridByUserId?.data)
            setServerTotal(costCenterGridByUserId?.totalRecords)
            setShowGrid(true)
            assignColumns()
        } else {
            setTableData([])
            setServerTotal(0)
            setShowGrid(false)
        }
    }, [costCenterGridByUserId])

    const handleClickBack = () => {
        navigate('/assetinventory')
    }

    const breadcrumlist = [
        { text: 'Users', key: 'f1', href: '/assetinventory', onClick: (e: any) => { e.preventDefault(); navigate('/assetinventory'); } },
        { text: 'Branch Admin Access', key: 'f2' }
    ]

    const onUserChange = (e: any, item: any) => {
        setSelectedUser(e)
        setUserSearchText('')
        dispatch(getBranchAdminUserDetails(e?.value))
        if (e?.value) {
            fetchGridData(e, paginationData?.current, sortData.current)
        }
    }

    const onUserInputChange = (value: any, action: any) => {
        if (action.action === "input-change") {
            setUserSearchText(value)
        }
    }

    useEffect(() => {
        if (userSearchText?.length > 2) {
            dispatch(getUserOnSearch(userSearchText.replace(/[^\w\s]/gi, "")));
        }
    }, [userSearchText])

    const userSelectOnBlur = () => {
        setUserSearchText("")
    }


    const onClickRemove = (e: any, rowData?: any) => {
        e.preventDefault();
        let decriptionTxt = (<p>Are you sure you want to remove this cost center?</p>);
        commonPopupDialog("CONFIRMATION", decriptionTxt, "No", false, "Yes", ConfirmationBee, "confirmationPopup", rowData?.costCenterId)

    }

    const getPaginationData = (pageData?: any) => {
        if (pageData?.pageIndex != undefined) {
            return pageData?.pageIndex + 1
        } else {
            return 1
        }
    }

    const fetchGridData = (selectedUser?: any, pageData?: any, sortingData?: any) => {
        if (selectedUser?.value) {
            let payload: any = {
                pageNumber: getPaginationData(pageData),
                pageSize: pageData?.pageSize,
                userId: parseInt(selectedUser?.value)
            }
            if (sortingData?.key != '') {
                payload.sortBy = sortingData?.key;
                payload.sortOrder = sortingData?.sortDirection;
            }
            dispatch(getCostCenterGridByUserId(payload))
        }
    }

    const fetchAction = useCallback((fetchData: any) => {
        if (fetchData.action && fetchData.action === "paging") {
            paginationData.current = fetchData.data
            //setPaginationData(fetchData.data)
            fetchGridData(selectedUser, fetchData.data, sortData.current)
        }
        if (fetchData.action && fetchData.action === "sorting") {
            sortData.current = fetchData.data[0]
            //setSortData(fetchData.data[0]);
            fetchGridData(selectedUser, paginationData.current, fetchData.data[0])
        }
    }, [selectedUser])

    useEffect(() => {
        if (serverTotal && paginationData?.current?.pageSize) {
            let pageSize = paginationData?.current?.pageSize
            let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
            setPagesCount(tempPageCount)
        }
    }, [serverTotal, paginationData?.current?.pageSize])

    const handleClickAddNew = () => {
        setShowModalPopup(true);
        setCostCenterError('')
        setSelectedSearchedCostCenter(null)
        setCostCenterSearchText('')
    }

    const hideDialog = () => {
        setShowModalPopup(false);
        setSelectedSearchedCostCenter(null)
        setCostCentersBySearchList([])
        setCostCenterError('')
    }

    const handleChangeSearchedCostCenter = (value: any, name: string) => {
        setSelectedSearchedCostCenter(value)
        setCostCenterSearchText('')
        setCostCenterError('')
    }

    const searchCostCenter = (value: any, action: any) => {
        if (action.action === "input-change") {
            setCostCenterSearchText(value)
        }
    };

    useEffect(() => {
        if (costCenterSearchText?.length > 2) {
            dispatch(getCostCenterBySearchString(costCenterSearchText))
        }
    }, [costCenterSearchText])

    const costCenterSelectOnBlur = () => {
        setCostCenterSearchText("")
    }

    const handleClickAddCostCenter = () => {
        if (selectedSearchedCostCenter) {
            dispatch(getIsCostCenterValidForSave({
                userId: selectedUser?.value,
                costCenterId: selectedSearchedCostCenter?.value
            }))
            setCostCenterError("")
        } else {
            setCostCenterError("Please select Cost Center");
        }
    }

    const commonPopupDialog = (title: string, description: any, outlineBtnText: string, isSingleConfirmationBtn: any, popupPrimaryBtnText: any, titleImage?: any, type?: any, deleteId?: any) => {
        setPopupContent({
            ...PopupContent,
            title: title,
            titleImg: titleImage,
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: description,
            outlineBtnText: outlineBtnText,
            isSingleConfirmationBtn: isSingleConfirmationBtn,
            popupOutlinebtnOnclick: () => {
                hidePopupDialog();
                if (type == "successPopup") {
                    fetchGridData(selectedUser, paginationData?.current, sortData.current)
                    setShowModalPopup(false);
                }
            },
            primaryBtnText: popupPrimaryBtnText,
            popupPrimarybtnOnclick: () => {
                hidePopupDialog()
                if (type == "confirmationPopup") {
                    dispatch(getRemoveCostCenterForUser({
                        costCenterId: deleteId,
                        savedBy: loginUserDetails?.emailId,
                        userId: selectedUser?.value
                    }))
                }
            }
        });
    }

    const hidePopupDialog = () => {
        setPopupContent({ ...PopupContent, isDialogVisible: false })
    };

    return (
        <BranchAdminAccess
            handleClickBack={handleClickBack}
            breadcrumlist={breadcrumlist}
            userSearchText={userSearchText}
            selectedUser={selectedUser}
            onUserChange={onUserChange}
            onUserInputChange={onUserInputChange}
            userSelectOnBlur={userSelectOnBlur}
            userOptions={userOptions}
            branchAdminUserDetails={branchAdminUserDetails}
            columns={gridColumn}
            fetchAction={fetchAction}
            serverTotal={serverTotal}
            pagesCount={pagesCount}
            tableData={tableData}
            showGrid={showGrid}
            handleClickAddNew={handleClickAddNew}
            hideDialog={hideDialog}
            showModalPopup={showModalPopup}
            handleChangeSearchedCostCenter={handleChangeSearchedCostCenter}
            searchCostCenter={searchCostCenter}
            costCentersBySearchList={costCentersBySearchList}
            selectedSearchedCostCenter={selectedSearchedCostCenter}
            costCenterSearchText={costCenterSearchText}
            costCenterSelectOnBlur={costCenterSelectOnBlur}
            handleClickAddCostCenter={handleClickAddCostCenter}
            PopupContent={PopupContent}
            hidePopupDialog={hidePopupDialog}
            costCenterError={costCenterError}
        />
    );
}
export default BranchAdminAccessContainer;